import React from "react";
import "../pages/About.css";
import cv from "../assets/CV.pdf";
import { BsDownload } from "react-icons/bs";
import DecryptedText from "../components/DecryptedText";


const About = () => {
  const paragraph1 =
    "Ever since I was introduced to technology, I’ve been fascinated by how ideas can turn into solutions that truly make an impact. For me, coding isn’t just about writing code, it’s about creating tools that improve lives and open new possibilities.";
  const paragraph2 =
    "When I’m not working on projects, you’ll probably find me exploring new tech trends, brainstorming product ideas, or challenging myself with something I’ve never built before. I believe growth comes from curiosity, and that’s what keeps me motivated as a developer.";

  const scrambleText = (text, highlights = [], speed = 80) => {
    return text.split(" ").map((word, i) => (
      <React.Fragment key={i}>
        <DecryptedText
          text={word}
          speed={speed}
          animateOn="view"
          className={highlights.includes(word) ? "highlight" : ""}
        />{" "}
      </React.Fragment>
    ));
  };



  return (
    <section className="about" id="about">
      <div className="about-content" data-aos="fade-left">
        <h2>
          About{" "}
          <span>
            <DecryptedText
              text="Me"
              speed={50}
              sequential={true}
              revealDirection="center"
              animateOn="view"
            />
          </span>
        </h2>

        <p>{scrambleText(paragraph1, ["technology", "coding"])}</p>
        <p>{scrambleText(paragraph2, ["curiosity"])}</p>

        <a href={cv} download className="btn download-btn">
          <BsDownload style={{ marginRight: "0.5rem" }} /> Download CV
        </a>

        {/* Candle Fun Animation */}
        <div className="candle-wrapper">
          <div className="candles">
            <div className="light__wave"></div>
            <div className="candle1">
              <div className="candle1__body">
                <div className="candle1__eyes">
                  <span className="candle1__eyes-one"></span>
                  <span className="candle1__eyes-two"></span>
                </div>
                <div className="candle1__mouth"></div>
              </div>
              <div className="candle1__stick"></div>
            </div>

            <div className="candle2">
              <div className="candle2__body">
                <div className="candle2__eyes">
                  <div className="candle2__eyes-one"></div>
                  <div className="candle2__eyes-two"></div>
                </div>
              </div>
              <div className="candle2__stick"></div>
            </div>
            <div className="candle2__fire"></div>
            <div className="candle__smoke-one"></div>
            <div className="candle__smoke-two"></div>
          </div>
          <div className="floor"></div>
        </div>
      </div>
    </section>
  );
};

export default About;
